import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderProgrammingCode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.753 5.461 8.58 3.703a.83.83 0 0 0-.694-.371h-3.72c-.92 0-1.667.746-1.667 1.667v10c0 .92.746 1.666 1.667 1.666h11.666c.92 0 1.667-.746 1.667-1.666v-7.5c0-.92-.746-1.667-1.667-1.667h-5.387a.83.83 0 0 1-.693-.371"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.667 10.833h1.667M7.5 9.166l1.667 1.667L7.5 12.499"
    />
  </svg>
);
export default SvgFolderProgrammingCode;
